import { Checkbox, FormControlLabel } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';

export const getAssessmentOverviewColumns = (
  onToggleEnableChange: (id: string) => void
): GridColDef[] => {
  return [
    {
      field: 'grade',
      headerName: 'Grade',
      flex: 1,
      minWidth: 80
    },
    {
      field: 'division',
      headerName: 'Division',
      flex: 1,
      minWidth: 80
    },
    {
      field: 'term',
      headerName: 'Term',
      flex: 1,
      minWidth: 80
    },
    {
      field: 'exam',
      headerName: 'Exam',
      flex: 1,
      minWidth: 80
    },
    {
      field: 'weightage',
      headerName: 'Weightage',
      flex: 1,
      minWidth: 100
    },
    {
      field: 'subject',
      headerName: 'Subject',
      flex: 1,
      minWidth: 150,
      maxWidth: 150
    },
    {
      field: 'scoringType',
      headerName: 'Scoring Type',
      flex: 1,
      minWidth: 100,
      maxWidth: 100
    },
    {
      field: 'maxMarks',
      headerName: 'Max Marks',
      flex: 1,
      type: 'number',
      minWidth: 100
    },
    {
      field: 'totalStudents',
      headerName: 'Total Students',
      flex: 1,
      type: 'number',
      minWidth: 120
    },
    {
      field: 'studentMarksEntered',
      headerName: 'Student Marks Entered',
      flex: 1,
      type: 'number',
      minWidth: 160
    },
    {
      field: 'percentage',
      headerName: 'Percentage',
      flex: 1,
      minWidth: 100,
      type: 'number'
    },
    {
      field: 'enableEvaluation',
      headerName: 'Enable Evaluation?',
      flex: 1,
      minWidth: 160,
      renderCell: (params: any) => (
        <FormControlLabel
          style={{ marginTop: '-10px', marginLeft: '0px' }}
          control={
            <Checkbox
              checked={!!params.value}
              onChange={() => onToggleEnableChange(params?.id)}
            />
          }
          label=''
        />
      )
    }
  ];
};
